/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class SmartTilePropServiceCategory implements angular.IComponentOptions {
        templateUrl = 'app/components/controls/smartCenterDesigner/propertyViews/smartTilePropServiceCategory.component.html';
        bindings: any = {
            prop: '=?',
            selectionChanged: '&?',
        };
        controller = class SmartTilePropServiceCategoryController {
            static $inject = [
                'meevo.components.common.DataService',
                '$translate'
            ];

            public prop: Meevo.Model.SmartTileParameter;
            public selectedServiceCategory: Model.ServiceCategory;
            public allOption: Model.ServiceCategory;
            public selectionChanged: Function;

            constructor(
                protected dataService: Components.BaseClasses.IDataService,
                protected $translate: angular.translate.ITranslateService                
            ) {
                this.allOption = {
                    id: null,
                    displayName: this.$translate.instant("LABEL_ALL_SERVICE_CATEGORIES"),
                };
            }

            $onInit(): void {
                if (this.prop && this.prop.parameterValue) {
                    this.selectedServiceCategory = {
                        id: this.prop.parameterValue,
                        displayName: this.prop.parameterDisplayName
                    };
                } else {
                    this.selectedServiceCategory = this.allOption;
                }
            }

            onSelectionChanged(): void {
                if (!this.selectedServiceCategory) {
                    this.selectedServiceCategory = this.allOption;
                }
                this.prop.parameterValue = this.selectedServiceCategory.id;
                this.prop.parameterDisplayName = this.selectedServiceCategory.displayName;
                this.selectionChanged({ selection: this.selectedServiceCategory });
            }

            addServiceCategoryAll(response: any, request: any) {
                if (request.pageNumber === 0) {
                    response.splice(0, 0, this.allOption);
                    return response;
                }                
            }            
        }
    }

    angular.module('meevo.components.controls')
        .component('stpServiceCategory', new SmartTilePropServiceCategory());
}
